import { PRICE_KEY } from './pricing'
import type { PriceKey } from './pricing'

export const CONVERSIONS: Readonly<Record<string, readonly string[]>> = {
  obj: ['stl', 'glb'],
  stl: ['obj'],
  fbx: ['obj'],
  sldprt: ['obj', 'stl', 'step'],
  sldasm: ['obj', 'stl', 'step'],
}

const AR_FORMAT = 'glb'

export function conversionPriceKey(source: string, target: string): PriceKey {
  if (SOLIDWORKS_EXTENSIONS.includes(source.toLowerCase())) return PRICE_KEY.bridgeConvert
  if (target === AR_FORMAT) return PRICE_KEY.ar
  return target === 'stl' ? PRICE_KEY.convertStl : PRICE_KEY.convertObj
}

const LABELS: Readonly<Record<string, string>> = {
  obj: 'OBJ',
  fbx: 'FBX',
  stl: 'STL',
  step: 'STEP',
  glb: 'AR',
  png: 'PNG',
  jpeg: 'JPEG',
  webp: 'WebP',
  sldprt: 'SLDPRT',
  sldasm: 'SLDASM',
}

export function formatLabel(format: string | null | undefined): string {
  if (!format) return ''
  return LABELS[format.toLowerCase()] ?? format.toUpperCase()
}

function extensionOf(filename: string): string {
  return filename.split('.').pop()?.toLowerCase() ?? ''
}

const UPLOADABLE_EXTENSIONS: readonly string[] = ['obj', 'fbx', 'stl']

export const UPLOAD_ACCEPT = UPLOADABLE_EXTENSIONS.map((e) => `.${e}`).join(',')

export const SOLIDWORKS_EXTENSIONS: readonly string[] = [
  'sldprt',
  'sldasm',
  'slddrw',
  'sldlfp',
]

function isSolidWorksFile(filename: string): boolean {
  return SOLIDWORKS_EXTENSIONS.includes(extensionOf(filename))
}

const WATERMARK_EXTENSIONS: readonly string[] = ['png']

export const WATERMARK_ACCEPT = WATERMARK_EXTENSIONS.map((e) => `.${e}`).join(',')

const MAX_WATERMARK_BYTES = 8 * 1024 * 1024
const MAX_WATERMARK_MB = MAX_WATERMARK_BYTES / (1024 * 1024)

export function watermarkRejection(file: File): string | null {
  if (!WATERMARK_EXTENSIONS.includes(extensionOf(file.name))) {
    return 'Only .png images can be used as watermarks.'
  }
  if (file.size > MAX_WATERMARK_BYTES) {
    return `Watermarks are limited to ${MAX_WATERMARK_MB} MB.`
  }
  return null
}

const MAX_UPLOAD_BYTES = 150 * 1024 * 1024
const MAX_UPLOAD_MB = MAX_UPLOAD_BYTES / (1024 * 1024)

export function uploadRejection(file: File): string | null {
  if (isSolidWorksFile(file.name)) {
    return 'SolidWorks files stay on your machine — add them from the desktop bridge instead.'
  }
  if (!UPLOADABLE_EXTENSIONS.includes(extensionOf(file.name))) {
    return 'Only .obj, .fbx and .stl models can be uploaded.'
  }
  if (file.size > MAX_UPLOAD_BYTES) {
    return `Uploads are limited to ${MAX_UPLOAD_MB} MB.`
  }
  return null
}
